<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1 class="text-danger"><i class="el-icon-s-marketing"></i> Pro Ekranı</h1>
      </div>
      <div class="icerik yazdirma" style="height: calc(100vh + 15px);">
        <el-row :gutter="24">
          <el-col :span="16">
            <BinaAnaliz></BinaAnaliz>
          </el-col>
          <el-col :span="8">
            <BinaFatura @Data="Detay($event)"></BinaFatura>
          </el-col>
        </el-row>
      </div>
      <FaturaYazdir @Modal="Modal=false" v-if="Modal" :Modal="Modal" :Data="FaturaData"></FaturaYazdir>
    </div>
  </div>
</template>

<script>
import BinaAnaliz from "./Comp/BinaAnaliz";
import BinaFatura from "./Comp/BinaFatura";
import FaturaYazdir from "./Comp/FaturaYazdir";

export default {
  components: {FaturaYazdir, BinaFatura, BinaAnaliz},
  data() {
    return {
      Modal: false,
      FaturaData: null
    }
  },
  methods: {
    Detay(e) {
      this.Modal = true;
      this.FaturaData = e;
    },
    SayfaYukle() {
      //console.log(this.$route.path)
    }
  },
  created() {
    this.SayfaYukle();
    if (this.$store.getters.Admin == '0') this.$router.push("/403");
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/_Sim/_route.vue